import ContactEmail from '../HighlightCard/HighlightDetails/ContactEmail';
import CreatedDate from '../HighlightCard/HighlightDetails/CreatedDate';
import Field from '../HighlightCard/HighlightDetails/atomic/Field';
import Phone from '../HighlightCard/HighlightDetails/Phone';
import Status from '../HighlightCard/HighlightDetails/Status';
import { getCartHighlightFieldValues } from '../../utils/cartHighlightDetailsUtils';
import { CART_HIGHLIGHT_DETAILS } from '../../constants/dataTestIds';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CartHighlightDetails = ({
  properties
}) => {
  const {
    createdDate,
    email,
    phone,
    status
  } = getCartHighlightFieldValues({
    properties
  });
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "left",
    marginBlock: "400",
    "data-test-id": CART_HIGHLIGHT_DETAILS,
    children: [/*#__PURE__*/_jsx(CreatedDate, {
      value: createdDate
    }), /*#__PURE__*/_jsx(Status, {
      value: status
    }), /*#__PURE__*/_jsx(Phone, {
      value: phone
    }), /*#__PURE__*/_jsx(ContactEmail, {
      value: email
    }), /*#__PURE__*/_jsx(Field, {})]
  });
};
export default CartHighlightDetails;